/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settingsnav_Sessionmanagement2Inputs */

const zh_settingsnav_sessionmanagement2 = /** @type {(inputs: Settingsnav_Sessionmanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会话管理`)
};

const en_settingsnav_sessionmanagement2 = /** @type {(inputs: Settingsnav_Sessionmanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session Management`)
};

const es_settingsnav_sessionmanagement2 = /** @type {(inputs: Settingsnav_Sessionmanagement2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestión de sesiones`)
};

/**
* | output |
* | --- |
* | "Session Management" |
*
* @param {Settingsnav_Sessionmanagement2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const settingsnav_sessionmanagement2 = /** @type {((inputs?: Settingsnav_Sessionmanagement2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settingsnav_Sessionmanagement2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_settingsnav_sessionmanagement2(inputs)
	if (locale === "en") return en_settingsnav_sessionmanagement2(inputs)
	return es_settingsnav_sessionmanagement2(inputs)
});
export { settingsnav_sessionmanagement2 as "settingsNav_sessionManagement" }